import React from 'react';

export type PageNavigationFunction = (url: string) => void;

export const defaultPageNavigation: PageNavigationFunction = (url) => {
  window.open(url, '_self');
};

export const PageNavigationContext = React.createContext<PageNavigationFunction>(defaultPageNavigation);
